import React from 'react'
import { BlackButton } from 'app-view/components/buttons'
import { useP2POffer } from 'pages/P2PView/hooks/useP2POffer'
import { useTranslation } from 'react-i18next'
import { useStore } from 'app-engine/store'
import { useWizard } from 'app-view/components/Wizard'
import { Loader } from 'app-view/components/Spinner'
import { ModalText, ModalButtonsContainer } from 'app-view/components/Modal'
import { buyerCryptoAmountLessP2PFee, formattedDate, getDAOAmountFee } from 'app-view/lib/utils'
import { useP2PLabels } from 'pages/P2PView/hooks/useP2PLabels'

export const SellCancelledOffer: React.FC = () => {
  const { t, i18n } = useTranslation(['p2p'])
  const account = useStore.useAccount()
  const [, { close }] = useWizard()
  const [{ offer, loading }, { methodLabel }] = useP2POffer()
  const { isMethodDetails, buyerMethodDetailsLabelData } = useP2PLabels()

  if (loading) return <Loader text={`${t('creating_sell')}...`} />

  const onClose = () => {
    close()
  }

  const buyer = `<span>${offer.buyerLabel}</span> ${t('no_longer_wants_to_buy')}`
  const noMatchText =
    offer.cancelled_by === account
      ? t('you_cancelled_offer_to_sell')
      : t('offer_been_cancelled_to_sell')

  return (
    <>
      <ModalText
        dangerouslySetInnerHTML={{
          __html: t('sell_cancelled_offer', {
            sorry: offer.matched || offer.cancelled_by !== account ? `${t('we_are_sorry')}!` : '',
            buyerInfo: offer.matched ? buyer : noMatchText,
            amount: buyerCryptoAmountLessP2PFee(offer.amount),
            cryptoFee: getDAOAmountFee(offer.amount),
            method: methodLabel(offer.method),
            methodDetails: isMethodDetails ? buyerMethodDetailsLabelData : '',
            date: formattedDate(i18n.language, offer.updated_at || offer.created_at),
          }),
        }}
      />
      <ModalButtonsContainer>
        <BlackButton onClick={onClose}>{t('ok')}</BlackButton>
      </ModalButtonsContainer>
    </>
  )
}
